import { TFeedFilterByQueryStringNames } from "#next/components/explorer/base/explorerQueryStrings";

export type TTabNames = Exclude<TFeedFilterByQueryStringNames, "language">;

// Note that this is in the users locale time zone. Other users with the same date range may see different results.
export function toYYYYMMDD(date: Date) {
  const yyyy = date.getFullYear();
  const MM = (date.getMonth() + 1).toString().padStart(2, "0");
  const dd = date.getDate().toString().padStart(2, "0");
  return `${yyyy}-${MM}-${dd}`;
}

export const filterToTabNameMap: Readonly<Record<TTabNames, string>> = {
  hashtag: "hashtags",
  link: "links",
  platform: "platforms",
  username: "usernames",
  entity: "entities",
} as const;

export const filterToFieldNameMap: Readonly<Record<TTabNames, string>> = {
  hashtag: "hashtags",
  link: "links",
  platform: "platform",
  username: "username",
  entity: "entities",
};

export const languageArray = [
  "hateful",
  "violent",
  "offensive",
  "negative",
] as const;

export enum GraphType {
  spline = "spline",
  column = "column",
}

export interface SummaryViewerSeriesData {
  name: string;
  data: [number, number][];
  type: GraphType;
}
